<template>
	<div>
		<model :dialogVisible='dialogVisible' @cancel="cancel" @opened='opened' width='70%' title='监控视频'>
			<div class="model-warp">
				<div class="statistic">
					<div class="statistic-tab">
						<div class="statistic-name">
							现有羊只总数：
						</div>
						<div class="statistic-val">
							{{ foldData.num }}
						</div>
					</div>
					<div class="statistic-tab">
						<div class="statistic-name">
							异常羊只总数：
						</div>
						<div class="statistic-val">
							0
						</div>
						<img src="@/assets/yq/arrow.png" class="icon" alt="">
					</div>
					<div class="statistic-tab">
						<div class="statistic-name">
							饮水槽：
						</div>
						<div class="statistic-val">
							{{ foldData.trough }}/ <span class="statistic-unit">{{ foldData.temperature }}℃</span>
						</div>
					</div>

				</div>
				<div class="fold-content">
					<div class="fold-left">
						<div class="fold-status">
							<div class="status-item">
								<img class="status-img" v-if='foldData.status == 3' src="@/assets/yq/fold/excellent.png"
									alt="">
								<img class="status-img" v-if='foldData.status == 2' src="@/assets/yq/fold/good.png" alt="">
								<img class="status-img" v-if='foldData.status == 1' src="@/assets/yq/fold/bad.png" alt="">

							</div>
							<div class="status-item">
								<div class="item-val">
									{{ foldData.nh3 }}
								</div>
								<div class="item-name">
									<img class="icon" src="@/assets/yq/fold/icon7.png" alt="">
									<span class="label">氨气含量</span>
									<span class="unit">mg/m³</span>
								</div>
							</div>
							<div class="status-item">
								<div class="item-val">
									{{ foldData.pm2 }}
								</div>
								<div class="item-name">
									<img class="icon" src="@/assets/yq/fold/icon8.png" alt="">
									<span class="label">PM2.5</span>
									<span class="unit">mg/m³</span>
								</div>
							</div>
						</div>
						<div class="lineChart" id="lineChart"></div>
					</div>
					<div class="fold-right" style="position: relative;">
					<!-- <div id="myPlayer" ref='device_box'></div> -->

					<video :src="`/yq/video${activeIndex + 1}.mp4`" autoplay loop width="100%"
						height="100%"></video>
					<span style="position: absolute;top:.3rem;left: .5rem;color: #fff;font-size: .25rem;">{{ current }}&nbsp;{{ time
					}}</span>

					</div>
				</div>
				<div class="panel-warp">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">温度</span>
							<img src="@/assets/yq/fold/icon1.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData?.temperature.val }}</span>
							<span class="panel-unit">℃</span>
						</div>
						<div class="panel-bottom">
							<span class="panel-staus" :class='getStatus(foldData.statData?.temperature)'>适中</span>

						</div>
					</div>
					<img src="@/assets/yq/fold/line.png" alt="" class="line">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">湿度</span>
							<img src="@/assets/yq/fold/icon2.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData.rm.val }}</span>
							<span class="panel-unit">/rm</span>
						</div>
						<div class="panel-bottom">
							<span class="panel-staus" :class='getStatus(foldData.statData.rm)'>适中</span>
						</div>
					</div>
					<img src="@/assets/yq/fold/line.png" alt="" class="line">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">气压</span>
							<img src="@/assets/yq/fold/icon3.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData.kpa.val }}</span>
							<span class="panel-unit">kpa</span>
						</div>
						<div class="panel-bottom">
							<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
							<span class="panel-staus" :class='getStatus(foldData.statData.kpa)'>适中</span>

						</div>
					</div>
					<img src="@/assets/yq/fold/line.png" alt="" class="line">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">硫化氢</span>
							<img src="@/assets/yq/fold/icon4.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData.h2s.val }}</span>
							<span class="panel-unit">mg/m³</span>
						</div>
						<div class="panel-bottom">
							<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
							<span class="panel-staus" :class='getStatus(foldData.statData.h2s)'>{{
								foldData.statData.h2s.name }}</span>

						</div>
					</div>
					<img src="@/assets/yq/fold/line.png" alt="" class="line">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">氮气</span>
							<img src="@/assets/yq/fold/icon5.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData.n2.val }}</span>
							<span class="panel-unit">%</span>
						</div>
						<div class="panel-bottom">
							<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
							<span class="panel-staus" :class='getStatus(foldData.statData.n2)'>适中</span>

						</div>
					</div>
					<img src="@/assets/yq/fold/line.png" alt="" class="line">
					<div class="panel">
						<div class="panel-top">
							<span class="panel-name">二氧化碳</span>
							<img src="@/assets/yq/fold/icon6.png" class="icon" alt="">
						</div>
						<div class="panel-mid">
							<span class="panel-val">{{ foldData.statData.co2.val }}</span>
							<span class="panel-unit">mg/m³</span>
						</div>
						<div class="panel-bottom">
							<!-- <el-tag style="width: 0.45rem;height: 0.24rem;font-size: 0.15rem;" effect="dark"  color="#00FF34">适中</el-tag> -->
							<span class="panel-staus" :class='getStatus(foldData.statData.co2)'>{{
								foldData.statData.co2.name }}</span>

						</div>
					</div>
				</div>

			</div>
		</model>
	</div>
</template>

<script>
import model from './model.vue'
export default {
	components: {
		model
	},
	props: {
		dialogVisible: {
			type: Boolean,
			default: false
		},
		videoData: {
			type: Object,
			default: () => {
				{ }
			}
		},
		activeIndex: {
			type: Number,
			default: 0
		}

	},
	data() {
		return {

			foldData: {
				name: '养殖圈舍1号',
				num: 150,
				trough: 2,
				temperature: 30,
				status: 3,
				nh3: 1,
				pm2: 85,

				statData: {
					temperature: {
						val: '14.0',
						name: '适中',
						status: 3,


					},
					rm: {
						val: '55',
						name: '适中',
						status: 3


					},
					kpa: {
						val: '85.50',
						name: '适中',
						status: 3

					},
					h2s: {
						val: '2',
						name: '优秀',
						status: 3

					},
					n2: {
						val: '78',
						name: '适中',
						status: 3

					},
					co2: {
						val: '500',
						name: '优秀',
						status: 3

					},


				}


			},
			nh3: '0',
			chartDataList: [
				[{
					title: '氨气含量',
					month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
						'09:00'
					],
					value: [2, 6, 8, 5, 1, 3, 7, 9, 5, 6]
				},],
				[{
					title: '氨气含量',
					month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
						'09:00'
					],
					value: [6, 16, 10, 13, 19, 5, 17, 19, 15, 16]
				},],
				[{
					title: '氨气含量',
					month: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00',
						'09:00'
					],
					value: [12, 6, 28, 35, 28, 23, 37, 32, 29, 36]
				},]
			],
			foldDataList: [{
				name: '养殖圈舍1号',
				num: 150,
				trough: 2,
				temperature: 30,
				status: 3,
				nh3: 1,
				pm2: 85,

				statData: {
					temperature: {
						val: '14.0',
						name: '适中',
						status: 3,


					},
					rm: {
						val: '55',
						name: '适中',
						status: 3


					},
					kpa: {
						val: '85.50',
						name: '适中',
						status: 3

					},
					h2s: {
						val: '2',
						name: '优秀',
						status: 3

					},
					n2: {
						val: '78',
						name: '适中',
						status: 3

					},
					co2: {
						val: '500',
						name: '优秀',
						status: 3

					},


				}


			},
			{
				name: '养殖圈舍2号',
				num: 145,
				trough: 2,
				temperature: 30.5,
				status: 2,
				nh3: 13,
				pm2: 91,

				statData: {
					temperature: {
						val: '14.2',
						name: '适中',
						status: 3

					},
					rm: {
						val: '58',
						name: '适中',
						status: 3

					},
					kpa: {
						val: '85.48',
						name: '适中',
						status: 3

					},
					h2s: {
						val: '4',
						name: '良好',
						status: 2

					},
					n2: {
						val: '78',
						name: '适中',
						status: 3

					},
					co2: {
						val: '960',
						name: '良好',
						status: 2

					},


				}


			}, {
				name: '养殖圈舍3号',
				num: 160,
				trough: 2,
				temperature: 30.2,
				status: 1,
				nh3: 32,
				pm2: 140,

				statData: {
					temperature: {
						val: '13.8',
						name: '适中',
						status: 3

					},
					rm: {
						val: '60',
						name: '适中',
						status: 3

					},
					kpa: {
						val: '85.50',
						name: '适中',
						status: 3

					},
					h2s: {
						val: '20',
						name: '较差',
						status: 1

					},
					n2: {
						val: '78',
						name: '适中',
						status: 3

					},
					co2: {
						val: '1600',
						name: '较差',
						status: 1

					},


				}


			}



			],
			time: null,
			week: null,
			timer: null,//定时器,
			current: null,
		};
	},
	watch: {

	},
	// 销毁定时器
	destroyed() {
		clearInterval(this.timer)
	},
	mounted() {
		this.getTime()
		this.$nextTick(() => {
			this.opened()

		})
	},

	methods: {
		cancel() {
			this.$parent.cancel()
		},
		getTime() {
			this.current = new Date().toLocaleDateString().replace(/\//g, '-');//获取当前日期（“年/月/日”）
			this.week = new Date().getDay();//获取当前星期（0~6，0代表星期天）
			if (this.timer) {
				clearInterval(this.timer)
			}
			this.timer = setInterval(() => {
				var time = new Date().toLocaleTimeString();//获取当前时间
				this.time = time
			}, 1000)
		},
		getStatus(item) {
			console.log(item)
			console.log(item.status)
			if (item.status == 1) {
				return 'bad'
			}
			if (item.status == 2) {
				return 'good'
			}
			if (item.status == 3) {
				return 'excellent'
			}

		},
		setCameras(item) {
			// setTimeout(() => {
			const _this = this
			// if (_this.decoder && _this.decoder.stop) {
			//     _this.decoder.stop()
			//     _this.decoder = {}
			//     _this.camerasListItem = {}
			//     document.getElementById('myPlayer').innerHTML = ''
			// }
			const w = this.$refs.device_box.offsetWidth
			const h = this.$refs.device_box.offsetHeight
			this.$nextTick(() => {
				if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
				_this.camerasListItem = item
				_this.decoder = new this.$EZUIKit.EZUIKitPlayer({
					id: 'myPlayer',
					url: _this.camerasListItem.url,
					accessToken: _this.camerasListItem.accessToken,
					autoplay: true,
					decoderPath: '/ezuikit',
					width: w,
					height: h,
					splitBasis: 1,
				})
			})
			// this.videoModelShow = true
			// }, 5000)

		},
		opened() {
			console.log(this.videoData)
			console.log(this.activeIndex)
			this.foldData = this.foldDataList[this.activeIndex]
			console.log(this.foldData)
			this.getPlayUrl(this.videoData)

			this.setLineData(this.chartDataList[this.activeIndex], 'lineChart')
			// this.setCameras({
			// 	url:'ezopen://open.ys7.com/L43187400/1.hd.live',
			// 	accessToken:'at.4ky0jdga38w9cf499y8hdif64eauuc8z-2h7p9ctnzx-1yxjxva-ueaplo52q'
			// })
		},
		getPlayUrl(videoData) {
			let params = {
				deviceCode: videoData.deviceCode,
				channelCode: videoData.channelCode
			}
			if (videoData.deviceType == 3) {
				params.ezvizId = videoData.ezvizId;
			}

			this.$http({
				url: 'ffsapp-service/ezviz/getPlayUrl',
				// url: 'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl',
				//请求方式
				method: 'post',
				//传递的参数
				data: {
					deviceCode: videoData.deviceCode,
					channelCode: videoData.channelCode,
					ezvizId: videoData.ezvizId
				},
			}).then(res => {
				const data = res.data;
				if (data.code === 200) {
					this.video = data.result
					console.log(data.result)
					this.setCameras(data.result)
				} else if (data.code === 500 || data.message) {
					// this.$message.error(data.message);
				}
			})
		},
		setLineData(data, dom, index) {
			const colors = ['#00FEFF', '#FFF200', '#40FF00'];
			const legend = [];
			const series = [];
			let xAxis = [];

			data.forEach((item, index) => {

				xAxis = item.month
				series.push({
					name: item.title,
					type: "line",
					smooth: true,
					showSymbol: false,
					areaStyle: {
						color: {
							type: 'linear',
							x: 0,
							y: 0,
							x2: 0,
							y2: 1,
							colorStops: [{
								offset: 0,
								color: 'rgba(0,246,236,0.48)' // 0% 处的颜色
							}, {
								offset: 1,
								color: 'rgba(91,233,255,0)' // 100% 处的颜色
							}],
							global: false // 缺省为 false
						}
					},
					lineStyle: {
						width: 2,
					},
					color: colors[index],
					data: item.value,
				})
			})
			const line = {
				dom,
				xAxis,
				legend: {
					data: legend,
					// x: 'right',
					// y: 'top',
					top: "0%",
					right: "3%",
					itemWidth: 8,
					itemHeight: 8,
					padding: [10, 0, 0, 0],
				},
				series: series
			}
			this.lineChart(line, index)
		},
		lineChart(data, index) {
			this.chart = this.$echarts.init(document.getElementById(data.dom))
			// 隐藏动画加载效果。

			var option = {
				color: ['#FFF200', '#00FEFF', '#FFF200'],
				tooltip: {
					trigger: 'axis',
					padding: [5, 20],
					backgroundColor: 'rgba(255,255,255,0.8)',
					// borderColor: 'rgba(18, 36, 132, 1)',
					borderColor: '#292929',
					borderWidth: 1,
					textStyle: {
						color: '#050F37',
					},
					formatter: (e) => {
						this.foldData.nh3 = e[0].data
						// this.nh3 = e[0].data
						console.log(this.nh3)
						this.$forceUpdate()


					}
				},
				legend: data.legend,
				grid: {
					top: '20%',
					left: '5%',
					right: '4%',
					bottom: '10%',
					containLabel: true,
				},
				xAxis: {
					type: 'category',
					boundaryGap: false,

					axisLabel: {
						color: '#00FEFF',
						fontSize: '0.13rem',
					},
					axisLine: {

						show: true, // X轴 网格线 颜色类型的修改
						// symbolSize: [10, 15],
						symbolOffset: [0, 0],
						lineStyle: {
							color: '#5BE9FF',
							type: 'solid',
						},
					},
					axisTick: {
						// X轴线 刻度线
						show: true,
						inside: true,
						alignWithLabel: false
					},
					axisPointer: {
						lineStyle: {
							color: '#00F6EC',
							type: 'solid'
						},
						value: 8,
						snap: true,
						handle: {
							show: true
						}
					},
					data: data.xAxis,
				},
				yAxis: {
					name: 'mg/m³',
					nameTextStyle: {
						color: '#00FEFF',
						padding: [3, 30, 0, 0],
						fontSize: '0.1rem',
					},
					// max: 320,
					scale: false,
					type: 'value',
					splitNumber: 6,

					axisLine: {
						// symbol: ['none', 'arrow'],
						// show: true, // X轴 网格线 颜色类型的修改
						// // symbolSize: [10, 15],
						// symbolOffset: [0, 12],
						// lineStyle: {
						// 	color: 'rgba(255,0,0,1)',
						// 	type: 'solid',
						// },
					},
					splitLine: {
						lineStyle: {
							type: 'soild',
							color: 'rgba(0,246,236,0.2)'
						}
					},
					axisLabel: {

						color: '#00FEFF',
						fontSize: '0.15rem',
					},
				},
				series: data.series,
			}
			this.chart.clear();
			this.chart.setOption(option)
			window.addEventListener('resize', () => {
				this.chart.resize()
			})
		},
	},
};
</script>
<style lang="scss" scoped>
.model-warp {
	padding-top: 0.68rem;
	padding-left: 0.25rem;
	padding-right: 0.25rem;

	.statistic {
		padding: 0.1rem 0.3rem;
		display: flex;
		justify-content: space-around;

		.statistic-tab {
			display: flex;
			align-items: center;

			.statistic-name {
				font-size: 0.18rem;
				font-family: Source Han Sans CN-Regular, Source Han Sans CN;
				font-weight: 400;
				color: #FFFFFF;
			}

			.statistic-val {
				font-size: 0.33rem;
				font-family: Impact-Regular, Impact;
				font-weight: 400;
				color: #FFF200;
				line-height: 0.5rem;

				.statistic-unit {
					font-family: Impact-Regular, Impact;
					font-weight: 400;
					color: #FFF200;
					font-size: 0.2rem;
				}
			}

			.icon {
				width: 0.31rem;
				height: 0.31rem;
				margin-left: 0.07rem;
			}
		}
	}

	.fold-content {
		width: 100%;
		display: flex;

		.fold-left,
		.fold-right {
			width: 50%;



		}

		.fold-right {
			// padding:.5rem 0.25rem;
			padding-left: 0.25rem;
			display: flex;
			align-items: end;
			padding-bottom: 0.3rem;

			#myPlayer {
				height: 80%;
				width: 100%;
				background-color: #fff;
				background: url('../../../assets/yq/loading.jpg');
				background-size: 100% 100%;

			}

			// padding-top: 1rem;
			// padding-bottom: 0.8rem;
		}
	}

	.fold-status {
		display: flex;
		// padding: 0 0.29rem;
		justify-content: space-between;
		align-items: center;
		margin-top: 0.86rem;

		.status-item {
			height: 1.1rem;
			width: 1.88rem;
			display: flex;
			flex-direction: column;
			align-items: center;

			.status-img {
				width: 1.88rem;
				height: 1.1rem;
			}

			.item-val {
				font-size: 0.4rem;
				font-family: DIN-Medium, DIN;
				font-weight: 500;
				color: #00FEFF;
				margin-top: 0.14rem;
				margin-bottom: 0.34rem;
			}

			.item-name {
				display: flex;
				align-items: center;
				justify-content: space-between;
				width: 100%;

				.icon {
					width: 0.21rem;
					height: 0.21rem;
				}

				.label {
					font-size: 0.15rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #00FEFF;
				}

				.unit {
					font-size: 0.13rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #00FEFF;
				}
			}
		}
	}

	.lineChart {
		height: 2.62rem;
		// height: 5.5rem;
		width: 100%;
		margin-top: .44rem;
	}

	.panel-warp {
		display: flex;
		justify-content: center;
		margin-top: 0.2rem;
		align-items: center;

		.line {
			width: 0.02rem;
			height: 1.49rem;
			display: flex;
		}

		.panel {
			margin-top: 0.06rem;
			margin-bottom: 0.2rem;
			width: 2.35rem;
			height: 1.49rem;
			margin-left: 0.5rem;

			.panel-top {
				text-align: left;

				.panel-name {
					font-size: 0.18rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #00FEFF;
					margin-right: 0.14rem;
				}

				.icon {
					height: 0.23rem;
				}
			}

			.panel-mid {
				margin-top: 0.31rem;
				text-align: center;

				.panel-val {
					font-size: 0.3rem;
					font-family: Source Han Sans CN-Medium, Source Han Sans CN;
					font-weight: 500;
					color: #00F6EC;
				}

				.panel-unit {
					font-size: 0.13rem;
					font-family: Source Han Sans CN-Regular, Source Han Sans CN;
					font-weight: 400;
					color: #00FEFF;
				}
			}

			.panel-bottom {
				margin-top: 0.15rem;

				.panel-staus {
					box-sizing: content-box;
					width: 0.45rem;
					height: 0.24rem;
					line-height: 0.24rem;
					// background: rgba(0, 255, 52, 0.6);
					border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
					font-size: 0.15rem;
					padding: 0.05rem 0.04rem;
					color: #fff;
					display: block;
					text-align: center;
				}
			}
		}
	}
}

.good {
	background: rgba(255, 161, 0, 0.9);
}

.bad {
	background: rgba(255, 34, 0, 0.9);
}

.excellent {
	background: rgba(0, 255, 52, 0.6);
}
</style>